import React from "react";
import { NavLink } from "react-router-dom";
import { Home, AlertTriangle } from "lucide-react";

export default function Page404() {
  return (
    <div className="min-h-[calc(100vh-120px)] bg-[#F9FAFB] flex flex-col items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-xl border border-gray-100 shadow-[0px_8px_30px_rgba(86,82,176,0.12)] p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-[rgb(86,82,176,0.08)] p-5 rounded-full shadow-[inset_0px_2px_6px_rgba(86,82,176,0.06)]">
            <AlertTriangle size={60} className="text-[#5652B0]" />
          </div>
        </div>

        <h1 className="text-2xl font-semibold text-gray-800 mb-2">
          Page Not Found
        </h1>
        <p className="text-gray-600 mb-8">
          Sorry, we couldn't find the page you're looking for. It might have
          been moved or doesn't exist.
        </p>

        <NavLink to="/">
          <button className="px-6 py-2.5 rounded-lg text-base font-medium text-white bg-[#5652B0] hover:bg-[#4A47A3] transition-all flex items-center justify-center mx-auto shadow-[0px_4px_12px_rgba(86,82,176,0.25)]">
            <Home size={18} className="mr-2" />
            Back to Home
          </button>
        </NavLink>
      </div>
    </div>
  );
}
